// @flow

import React, { Component } from "react";
import Alert from "react-s-alert";
import { Icon } from "react-fa";
import _ from "lodash";
import mapSeries from "async/mapSeries";

import App from "./App.jsx";
import TreeItemShp from "./TreeItemShp.jsx";
import TreeItemPng from "./TreeItemPng.jsx";
import TreeItemObs from "./TreeItemObs.jsx";
import TreeItemSen from "./TreeItemSen.jsx";
import TreeItemCollect from "./TreeItemCollect.jsx";

import { fetch_dir } from "./fetch_things.js";
import {
  noop,
  mk_title,
  abrev,
  path_is_inside_bi,
  ms_regex,
  culti_regex,
  takeFilename,
} from "./utils.js";
import get_order from "./orden.js";

import { T_DIR, T_MS, T_PNG } from "./codtype.js";
import type { T_Next, T_Item, T_Node } from "./types.js";
import type { TreeItem } from "./TreeItem.js";

/* eslint-disable no-use-before-define */

export type T_OpenNextDir = (item_dir: ?TreeItemDir) => void;

type T_TreeItemDirProps = {
  node: T_Item,
  indent: number,
  restrict_to: Array<string>,
  show_me: boolean,
  show_ms: boolean,
  parent_item: ?TreeItemDir,
  txt_search?: string,
  visible?: boolean,
  disabled: boolean,
  app: App,
};

/* eslint-enable no-use-before-define */

type T_TreeItemDirState = {
  show_menu: boolean,
  hilight_fm: boolean,
  hilight: boolean,
  List: Array<T_Item>,
  Loaded: boolean,
  Open: boolean,
};

export default class TreeItemDir
  extends Component<T_TreeItemDirProps, T_TreeItemDirState>
  implements TreeItem
{
  dirs: Array<TreeItemDir>;
  shps: Array<TreeItemShp>;
  pngs: Array<TreeItemPng>;
  obss: Array<TreeItemObs>;
  sens: Array<TreeItemSen>;

  click: (ev: SyntheticMouseEvent<*>) => void;
  rclick: (ev: SyntheticMouseEvent<*>) => void;
  filter_ms_if: (item: T_Item) => boolean;

  constructor(props: T_TreeItemDirProps) {
    super(props);

    this.state = {
      Loaded: false,
      show_menu: false,
      hilight_fm: false,
      hilight: false,
      List: [],
      Open: false,
    };

    this.click = this.click.bind(this);
    this.rclick = this.rclick.bind(this);
    this.filter_ms_if = this.filter_ms_if.bind(this);
  }

  open(next: T_Next = noop): void {
    fetch_dir(this.props.app, this.props.node.Path, (response) => {
      if (typeof response === "string") {
        Alert.error(response);
        next(false);
      } else {
        const ns = (response: Array<T_Node>),
          es_mav = (file) => file.indexOf("mav_") === 0,
          files = ns
            .filter((nd) => this.props.app.mostrable(nd))
            .map(get_order),
          dirs = _.sortBy(
            files.filter((xi) => xi.Type === "dir"),
            [(xi) => xi.File.toLowerCase()]
          ),
          mavs = _.sortBy(
            files.filter((xi) => xi.Type === "shp"),
            ["order"]
          ).filter((si) => es_mav(si.File)),
          not_mavs = _.sortBy(
            files.filter((xi) => xi.Type === "shp"),
            ["order"]
          ).filter((si) => !es_mav(si.File)),
          pngs = _.sortBy(
            files.filter((xi) => xi.Type === "png"),
            ["order"]
          ),
          obss = _.sortBy(
            files.filter((xi) => xi.Type === "obs"),
            ["order"]
          ),
          collects = _.sortBy(
            files.filter((xi) => xi.Type === "collect"),
            ["order"]
          ),
          pdfs = files.filter((xi) => xi.Type === "pdf"),
          sens = _.sortBy(
            files.filter((xi) => xi.Type === "sensor"),
            ["order"]
          );

        this.setState(
          {
            List: dirs
              .concat(not_mavs)
              .concat(pngs)
              .concat(mavs)
              .concat(obss)
              .concat(sens)
              .concat(pdfs)
              .concat(collects),
            Open: true,
            Loaded: true,
          },
          () => next(true)
        );
      }
    });
  }

  close(next: T_Next = noop): void {
    this.setState({ Open: false }, () => next(true));
  }

  toggle(next: T_Next = noop): void {
    if (this.props.disabled) {
      return;
    }

    if (!this.state.Loaded) {
      this.open(() => next(true));
    } else if (this.state.Open) {
      this.close(next);
    } else {
      this.setState({ Open: true }, () => next(true));
    }

    if (this.props.toolbar !== undefined) {
      this.props.toolbar.setState({ show_tabla_oport: false });
    }
  }

  click(ev: SyntheticMouseEvent<*>): void {
    ev.stopPropagation();

    if (
      this.props.app.toolbar &&
      !!this.props.app.toolbar.state.show_tabla_oport
    ) {
      this.props.app.toolbar.setState({ show_tabla_oport: false });
    }

    if (ev.button === 0) {
      this.toggle();
    }
  }

  rclick(ev: SyntheticMouseEvent<*>): void {
    if (this.get_path() !== "/MAPS") {
      this.props.app.setState(
        {
          tree_item_menu: {
            px: ev.pageX,
            py: ev.pageY,
            node: this.props.node,
          },
        },
        () => {
          this.setState({ hilight_fm: true });
        }
      );
    }
  }

  refresh_all_sons(next: T_Next = noop): void {
    mapSeries(
      this.shps,
      (item_shp: TreeItemShp, callback1) => {
        item_shp.refresh(() => callback1(null, true));
      },
      (err, rs) => {
        mapSeries(
          this.pngs,
          (item_png: TreeItemPng, callback2) => {
            item_png.refresh(() => callback2(null, true));
          },
          (err, rs) => {
            mapSeries(
              this.obss,
              (item_obs: TreeItemObs, callback3) => {
                item_obs.refresh(() => callback3(null, true));
              },
              (err, rs) => {
                mapSeries(
                  this.sens,
                  (item_sen: TreeItemSen, callback4) => {
                    item_sen.refresh(() => callback4(null, true));
                  },
                  (err, rs) => {
                    next(true);
                  }
                );
              }
            );
          }
        );
      }
    );
  }

  toggle_publish(next: T_Next): void {
    const List = _.cloneDeep(this.state.List).map((xx) => {
      if (xx.Cod === T_PNG) {
        xx.Unpub = !xx.Unpub;
      }

      return xx;
    });

    this.setState({ List }, () => next(true));
  }

  match(node: T_Item): boolean {
    // match se usa para las búsquedas hechas en un folder
    if (this.props.txt_search) {
      const { txt_search } = this.props;

      if (txt_search.length === 0 || node.Cod !== T_DIR) {
        return true;
      } else {
        return (
          node.File.toLowerCase().split("_").join(" ").indexOf(txt_search) !==
          -1
        );
      }
    } else {
      return true;
    }
  }

  found(path: string): boolean {
    // found se usa en las búsquedas hechas en un árbol
    return this.props.restrict_to.length === 0
      ? true
      : _.some(this.props.restrict_to, (re) => path_is_inside_bi(re, path));
  }

  open_parents(next: T_Next): void {
    const open_parent = () => {
      if (this.props.parent_item != null) {
        this.props.parent_item.open_parents(next);
      } else {
        next(false);
      }
    };

    if (!this.state.Open) {
      this.setState({ Open: true }, open_parent);
    } else {
      open_parent();
    }
  }

  total_screenshots(include_mavs: boolean, include_mts: boolean): number {
    const good_shp = (xi) =>
        xi.props.node.File.match(ms_regex) ||
        xi.props.node.File.match(culti_regex),
      good_png = (xi) => xi.props.node.File.indexOf("Mapa_Tematico_") === -1;

    let base =
      this.shps.filter(good_shp).length + this.pngs.filter(good_png).length;

    if (include_mavs) {
      const is_mav = (xi) => xi.props.node.File.indexOf("mav_") === 0;

      base += this.shps.filter(is_mav).length;
    }

    if (include_mts) {
      const is_mt = _.negate(good_png);

      base += this.pngs.filter(is_mt).length;
    }

    return base;
  }

  get_sub_dir(dir: string): ?TreeItemDir {
    if (this.props.node.Path === dir) {
      return this;
    } else {
      // FIXME: optimizar comparando los paths.
      for (const item_dir of this.dirs) {
        // puedes saber de antemano si esta búsqueda será útil o no.
        const res = item_dir.get_sub_dir(dir);

        if (res != null) {
          return res;
        }
      }

      return null;
    }
  }

  filter_ms_if(item: T_Item): boolean {
    if (item.Cod === T_MS && !this.props.show_ms) {
      return false;
    }

    return true;
  }

  get_path(): string {
    return this.props.node.Path;
  }

  get_file(): string {
    return this.props.node.File;
  }

  get_ms(): ?TreeItemShp {
    return this.shps.find((shp_item) => shp_item.props.node.Cod === T_MS);
  }

  get_mavs(): Array<TreeItemShp> {
    return this.shps.filter((shp_item) => shp_item.is_Mav());
  }

  get_mts(): Array<TreeItemPng> {
    return this.pngs.filter((png_item) => png_item.is_MT());
  }

  unclick_all(): void {
    this.dirs.forEach((item) => item.unclick_all());
    this.shps.forEach((item) => item.unclick());
    this.pngs.forEach((item) => item.unclick());
    this.obss.forEach((item) => item.unclick());
    this.sens.forEach((item) => item.unclick());
  }

  render() {
    const { app } = this.props,
      fontWeight = this.state.Open ? "bold" : "normal",
      lb_style = {
        fontWeight,
        color: "black",
        border: "0",
        paddingRight: 0,
        paddingLeft: 0,
      },
      style = { marginLeft: 15 * this.props.indent, marginTop: 0 };

    if (this.props.node.Unpub) {
      lb_style.color = "red";
    }

    if (this.state.hilight_fm) {
      lb_style.border = "1px solid red";
      lb_style.paddingRight = 3;
      lb_style.paddingLeft = 3;
    }

    this.dirs = [];
    this.shps = [];
    this.pngs = [];
    this.obss = [];
    this.sens = [];

    return (
      <div
        style={{
          display: _.has(this.props, "visible")
            ? this.props.visible
              ? "block"
              : "none"
            : "block",
        }}
      >
        {this.props.show_me && (
          <div
            style={style}
            className="treeItem"
            onClick={this.click}
            onContextMenu={this.rclick}
          >
            <Icon name={this.state.Open ? "angle-down" : "angle-right"} />

            <span style={lb_style} className="notranslate">
              {mk_title(
                abrev(
                  this.props.node.label === "spaco_agricola"
                    ? "spaço_agrícola"
                    : this.props.node.label || "label",
                  30
                )
              )}
            </span>
          </div>
        )}

        <div style={{ display: this.state.Open ? "block" : "none" }}>
          {this.state.List.filter(this.filter_ms_if).map((item) => {
            if (
              item.File.includes("desarrollo_biomasa") ||
              item.File.includes("ptos_de_control")
            ) {
              return null;
            }

            if (item.Cod === T_DIR) {
              return (
                <TreeItemDir
                  node={item}
                  indent={this.props.indent + 1}
                  restrict_to={this.props.restrict_to}
                  show_me={true}
                  show_ms={this.props.show_ms}
                  parent_item={this}
                  visible={this.match(item) && this.found(item.Path)}
                  disabled={this.props.disabled}
                  app={app}
                  key={item.Path.slice(6)}
                  ref={(comp) => {
                    if (comp != null) {
                      this.dirs.push(comp);
                    }
                  }}
                />
              );
            }

            if (item.Type === "shp") {
              return (
                <TreeItemShp
                  node={item}
                  indent={this.props.indent + 1}
                  parent_item={this}
                  disabled={this.props.disabled}
                  app={app}
                  key={item.Path.slice(6)}
                  ref={(comp) => {
                    if (comp != null) {
                      this.shps.push(comp);
                    }
                  }}
                />
              );
            }

            if (item.Cod === T_PNG) {
              return (
                <TreeItemPng
                  node={item}
                  indent={this.props.indent + 1}
                  parent_item={this}
                  disabled={this.props.disabled}
                  app={app}
                  key={item.Path.slice(6)}
                  ref={(comp) => {
                    if (comp != null) {
                      this.pngs.push(comp);
                    }
                  }}
                />
              );
            }

            if (item.Type === "obs") {
              return (
                <TreeItemObs
                  node={item}
                  indent={this.props.indent + 1}
                  parent_item={this}
                  disabled={this.props.disabled}
                  app={app}
                  key={item.Path.slice(6)}
                  ref={(comp) => {
                    if (comp != null) {
                      this.obss.push(comp);
                    }
                  }}
                />
              );
            }

            if (item.Type === "sensor") {
              return (
                <TreeItemSen
                  node={item}
                  indent={this.props.indent + 1}
                  parent_item={this}
                  disabled={this.props.disabled}
                  app={app}
                  key={item.Path.slice(6)}
                  ref={(comp) => {
                    if (comp != null) {
                      this.sens.push(comp);
                    }
                  }}
                />
              );
            }

            if (item.Type === "collect") {
              return (
                <TreeItemCollect
                  node={item}
                  indent={this.props.indent + 1}
                  parent_item={this}
                  disabled={this.props.disabled}
                  app={app}
                  key={item.Path.slice(6)}
                />
              );
            }

            if (item.Type === "pdf") {
              return (
                <div
                  className="treeItem"
                  key={item.Path.slice(6)}
                  style={{ marginLeft: 15 * (this.props.indent + 1) }}
                >
                  <span
                    onClick={() =>
                      app.download(
                        `${app.remote}/get-pdf/?path=${
                          item.Path
                        }&session_id=${app.session()}`,
                        takeFilename(item.Path)
                      )
                    }
                  >
                    Informe.pdf
                  </span>
                </div>
              );
            }

            return null;
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TreeItemDir.jsx